var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpendCategoryGroceries32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "24px",
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon//SpendCategory/Groceries32",
    transform: "translate(-8.000000, -4.000000)",
    fill: "#706D6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconGroceries"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PaperBag",
    transform: "translate(8.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.99961125,10.4146023 L1,11.4142136 L1,23 L14.9976215,23 L14.9700726,11.4037542 L14.02639,10.4222715 L12.0077657,12.4082885 L10.0171528,10.4187684 L8.04601715,12.416485 L6.02260723,10.4070567 L3.99267167,12.4098548 L1.99961125,10.4146023 Z M7.32926064,10.2953453 L8.03881836,11 L8.73890842,10.2904692 L10.012207,9 L12.0133057,11 L14.0461426,9 L15.9691162,11 L16,24 L0,24 L0,11 L2,9 L3.99780273,11 L6.02490234,9 L7.32926064,10.2953453 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Milk",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.57879639,5.49032834 L6,3 L5.99731445,2 L2,2 L2,3 L0,6 L0,10.0112915 L1,9.4545704 L1,6.30277564 L2.83205029,3.5547002 L3,3 L4.99999639,3 L5.16794971,3.5547002 L6.45836847,5.49032834 L7.57879639,5.49032834 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1 L2,2 L6,2 L6,1 L2,1 Z M1,0 L7,0 L7,3 L1,3 L1,0 Z",
    id: "Rectangle-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Apple",
    transform: "translate(5.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0 C5.56700338,0 4.5,1.0477773 4.5,2.98077393 L4.5,3.5 L5.5,3.64086914 L5.5,3 C5.49970702,2.37662732 5.68326008,1.87876355 6.05065918,1.50640869 C6.41805828,1.13405383 6.90117188,0.956258424 7.5,0.973022461 L7.5,0 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17794759,6.74439318 L1.09145236,7.23685493 L0.106528857,7.06386446 L0.193024091,6.57140272 C0.5504733,4.53626095 1.21669511,3.19502211 2.24315594,2.57248269 C2.65812523,2.32080749 3.04035835,2.28624417 3.43401714,2.44067396 C3.5299519,2.47830854 3.6202043,2.52342995 3.73616912,2.58830538 C3.74730927,2.59453763 3.93871717,2.70395411 3.9952184,2.73464665 C4.32405458,2.91327668 4.60266165,2.99715341 5.00356598,3.00001272 C5.42277617,3.00300258 5.69787076,2.92525703 6.02622891,2.75212886 C5.9453515,2.7947718 6.35366899,2.57174605 6.46582197,2.52180318 C6.86819177,2.34262382 7.25150544,2.33759906 7.70708322,2.54489942 C9.09343903,3.17572924 9.82646415,4.62026067 9.93709732,6.79317917 L9.96252167,7.29253236 L8.9638153,7.34338104 L8.93839096,6.84402786 C8.84492257,5.00823868 8.28611827,3.90703443 7.29291678,3.45510058 C7.10379753,3.36904615 7.01895156,3.37015837 6.87262074,3.43532098 C6.80384773,3.4659463 6.45217649,3.65803149 6.49262515,3.63670477 C6.02754574,3.88191978 5.59467861,4.00425405 4.99643402,3.99998728 C4.41555084,3.99584434 3.98132141,3.86511634 3.51788102,3.61336675 C3.44997604,3.57647948 3.25067266,3.46254963 3.24793745,3.46101944 C3.16823607,3.41643125 3.11411043,3.38937131 3.06881936,3.37160392 C2.96703696,3.33167534 2.91146894,3.33670006 2.76172687,3.42751731 C2.03550216,3.86796617 1.49042025,4.96532596 1.17794759,6.74439318 Z",
    id: "Line"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendCategoryGroceries32);
export default __webpack_public_path__ + "static/media/spendCategoryGroceries32.cae356d6b396349271826c876c45ff6f.svg";
export { ForwardRef as ReactComponent };